export const Russian = {
  language: 'ru',
  data: {
    TRANSLATOR: {
      SELECT: 'Выберите язык',
      ENGLISH: 'Английский',
      RUSSIAN: 'Русский',
    },
    MENU: {
      HOME: 'Главная',
      PROFILE: 'Мой профиль',
      ACCOUNT: 'Аккаунт',
      SETTINGS: 'Настройки',
      IDENTITY: 'Идентификация',
      NOTIFICATION: 'Уведомления',
      CONFIGURATION: 'Конфигурация',
      INFO: 'Информация',
      TICKETS: 'Тикеты',
      TITLE: 'Меню',
      ADMIN: 'Админ',
      MANAGE_COMPANIES: 'Управление компаниями',
      AUDITS: 'Аудиты',
      MANAGE_COMPLIANCE: 'Управление соответствием',
      MANAGE_AUDIT_TYPES: 'Управление типами аудитов',
      MANAGE_RULE_DATABASE: 'Управление базой правил',
      COMPLIANCE_REPORTING: 'Отчёты по соответствию',
      SUPPORT: 'Поддержка',
      DASHBOARDS: 'Панели',
      COMPLIANCE_VIOLATIONS_BREAKDOWN: 'Анализ нарушений соответствия',
      COMPLIANCE_VIOLATIONS_TRENDING: 'Тренды нарушений соответствия',
      MANAGE_USERS: 'Управление пользователями',
      MY_PROFILE: 'Мой профиль',
      MANAGE_ROLES: 'Управление ролями',
    },
    MODAL: {
      SAVE: 'Сохранить',
      CANCEL: 'Отмена',
      YES: 'Да, я уверен',
      NO: 'Нет, отменить',
      DELETE_MESSAGE: 'Вы уверены, что хотите удалить этот элемент?',
      ADD_NEW_USER: 'Добавить нового пользователя',
      ADD_NEW_ROLE: 'Добавить новую роль',
      EDIT_USER: 'Редактировать пользователя',
      EDIT_ROLE: 'Редактировать роль',
      VIEW_USER: 'Просмотр данных пользователя',
      DELETE_USER: 'Удалить пользователя',
      DELETE_ROLE: 'Удалить роль',
      UPDATE_USER_PASSWORD: 'Обновить пароль пользователя',
      EDIT_GROUP: 'Редактировать группу',
      DELETE: 'Удалить',
      EDIT_COMPANY: 'Редактировать компанию',
      ADD_COMPANY: 'Добавить компанию',
      ADD_RULE_DATABASE: 'Добавить базу правил',
      EDIT_RULE_DATABASE: 'Редактировать базу правил',
      EDIT_TYPE_PERMISSION: 'Редактировать права типа',
      ADD_TYPE_PERMISSION: 'Добавить права типа',
      ADD_RULE_AUTHORITY: 'Добавить полномочие правила',
      EDIT_RULE_AUTHORITY: 'Редактировать полномочие правила',
      ADD_RULE_FOLDER: 'Добавить папку правил',
      EDIT_RULE_FOLDER: 'Редактировать папку правил',
      ASSIGN_USER: 'Назначить пользователя',
    },
    TABLE: {
      NAME: 'Имя',
      OBJECT: 'Объект',
      READ: 'Чтение',
      WRITE: 'Запись',
      CREATE: 'Создать',
      DELETE: 'Удалить',
      NAVIGATE: 'Навигация',
      EMAIL: 'Электронная почта',
      PHONE: 'Телефон',
      MESSAGE: 'Сообщение',
      CREATION_TIME: 'Время создания',
      RESPONSE_TIME: 'Время ответа',
      TYPE: 'Тип',
      STATUS: 'Статус',
      ACTIONS: 'Действия',
      NO_DATA_AVAILABLE: 'Данные отсутствуют',
      FIRST_NAME: 'Имя',
      LAST_NAME: 'Фамилия',
      TITLE: 'Должность',
      PRIMARY_COMPANY: 'Основная компания',
      USERNAME: 'Имя пользователя',
      IS_ACTIVE: 'Активен',
      ROLE_NAME: 'Название роли',
      COMPANY_NAME: 'Название компании',
      AUDIT_COMPANY: 'Компания аудита',
      BRANCH_DEPARTMENT: 'Филиал / Отдел',
      PRIMARY_CONTACT: 'Основной контакт',
      AUDIT_NAME: 'Название аудита',
      AUDIT_TYPE: 'Тип аудита',
      VERSION: 'Версия',
      AUDIT_STATUS: 'Статус аудита',
      START_DATE: 'Дата начала',
      END_DATE: 'Дата окончания',
      ACTUAL_START_DATE: 'Фактическая дата начала',
      ACTUAL_END_DATE: 'Фактическая дата окончания',
      AUDITOR: 'Аудитор',
      REVIEWER: 'Рецензент',
      CITY: 'Город',
      STATE: 'Штат / Регион',
      ZIP: 'Индекс',
      CURRENT_USER: 'Текущий пользователь',
      BRANCH_DEPT: 'Филиал / отдел',
      CONTACT: 'Контакт',
      CLIENT_TYPE: 'Тип клиента',
      FULL_COMPANY_NAME: 'Полное название компании',
      COMPANY: 'Компания',
      PURCHASED_DATE: 'Дата покупки',
      COMPLIANCE_STATUS: 'Статус соответствия',
      BRANCH: 'Филиал',
      FULL_NAME: 'Полное имя',
      ADDRESSED_VIOLATIONS_COUNT: 'Количество устранённых нарушений',
      PENDING_VIOLATIONS_COUNT: 'Количество ожидающих нарушений',
      VIOLATIONS_TOTAL: 'Всего нарушений',
      AUTHORITY_NAME: 'Название органа',
      RULE_NUMBER: 'Номер правила',
      OUTCOME: 'Результат',
      COMMENT: 'Комментарий',
      ACTIVE: 'Активный',
      TYPE_PRICE: 'Цена типа',
      TYPE_NAME: 'Название типа',
      DATABASE_NAME: 'Название базы данных',
      ORDER: 'Порядок',
      LETTER: 'Письмо',
      DOC_ORDER: 'Порядок документа',
      DOCUMENT_NAME: 'Название документа',
      PASSWORD: 'Пароль',
      AGREED_TO_TERMS_DATE: 'Дата согласия с условиями',
      AGREED_IP_ADDRESS: 'IP-адрес при согласии',
      CHANGE_PASSWORD_ON_FIRST_LOGIN: 'Сменить пароль при первом входе',
      INDEX: 'Индекс',
      RULE_ORDER: 'Порядок правила',
      FILE: 'Файл',
      NUMBER: 'Номер',
      IS_CUSTOM: 'Пользовательский',
      RULE: 'Правило',
      SUB_DIVISION: 'Подразделение',
      SUB_DIVISION_NAME: 'Название подразделения',
      DIVISION: 'Отдел',
      DIVISION_NAME: 'Название отдела',
    },
    AUDIT_TYPES: {
      TITLE: 'Типы аудита',
      TYPE_NAME: 'Название типа',
      TYPE_PRICE: 'Цена типа',
      ACTIVE: 'Активный',
      VERSION: 'Версия',
      SUMMARY: 'Краткое описание',
      OBJECTIVES: 'Цели',
    },
    NOTIFICATIONS: {
      TITLE: 'Уведомления',
      ALERTS: 'Оповещения',
      UPDATES: 'Обновления',
      LOGS: 'Журналы',
      VIEW_ALL: 'Просмотреть все',
      UPGRADE: 'Обновить',
      GET_PRO_ACCESS: 'Получить Pro-доступ',
      ALL_ROLES: 'Все роли',
      ALL_USERS: 'Все пользователи',
      ALL_GROUPS: 'Все группы',
      ALL_STATUSES: 'Все статусы',
      NEW_NOTIFICATION: 'Новое уведомление',
      MARK_AS_READ: 'Отметить как прочитанное',
      SUBJECT: 'Тема',
      MESSAGE: 'Сообщение',
      TYPE: 'Тип',
      ROLE: 'Роль',
      USER: 'Пользователь',
      CREATION_TIME: 'Время создания',
      STATUS: 'Статус',
      ACTION: 'Действие',
      GROUP: 'Группа',
      NEW_NOTIFICATIONS: {
        ROLE_ID: 'ID роли',
        USER_NAME: 'Имя пользователя',
        TITLE: 'Заголовок',
        ALL: 'Все',
      },
    },
    GROUPS: {
      TITLE: 'Группы',
      NEW_GROUP: 'Новая Группа',
      NAME: 'Название',
      DESCRIPTION: 'Описание',
      ROLES: 'Роли',
      CREATION_TIME: 'Время Создания',
      ACTION: 'Действие',
    },
    IDENTITY: {
      TITLE: 'Идентичность',
      USERS: 'Пользователи',
      NEW_USER: 'Новый пользователь',
      NEW_ROLE: 'Новая роль',
      SEARCH: 'Поиск',
      USER_NAME: 'Имя пользователя',
      FIRST_NAME: 'Имя',
      PASSWORD: 'Пароль',
      LAST_NAME: 'Фамилия',
      EMAIL: 'Электронная почта',
      ROLE: 'Роль',
      ROLE_NAME: 'Название роли',
      ACTIONS: 'Действия',
      SHOW: 'Показано',
      TO: 'по',
      OF: 'из',
      ENTRIES: 'записей',
      DESCRIPTION: 'Описание',
    },
    COMMON: {
      SEARCH: 'Поиск',
      PAGINATION: 'Показано с {{from}} по {{to}} из {{all}} записей',
      NO_DATA_AVAILABLE_IN_TABLE: 'Данные в таблице отсутствуют',
      COPY_TO_CLIPBOARD: 'Скопировано в буфер обмена: {{value}}',
      GO_TO: 'Перейти на страницу',
      ITEMS_PER_PAGE: 'Элементов на странице',
    },
    AUTH: {
      // ? ACTUAL
      TITLES: {
        LOGIN: 'Вход в систему',
        REGISTER: 'Регистрация',
        FORGOT: 'Забыли пароль?',
        RESET_PASSWORD: 'Сброс пароля',
      },
      // ? ACTUAL
      GENERAL: {
        OR: 'Или',
        SUBMIT_BUTTON: 'Отправить',
        NO_ACCOUNT: 'Нет аккаунта?',
        SIGNUP_BUTTON: 'Зарегистрироваться',
        FORGOT_BUTTON: 'Забыли пароль?',
        BACK_BUTTON: 'Назад',
        PRIVACY: 'Конфиденциальность',
        LEGAL: 'Правовая информация',
        CONTACT: 'Контакты',
        PLEASE_WAIT: 'Пожалуйста, подождите',
        CONTINUE: 'Продолжить',
        LOG_ON: 'Войти',
      },
      LOGIN: {
        TITLE: 'Вход с помощью',
        BUTTON: 'Войти',
        NEW_HERE: 'Новый пользователь',
        CONTINUE_WITH_GOOGLE: 'Продолжить с Google',
      },
      FORGOT: {
        TITLE: 'Забыли пароль?',
        DESC: 'Введите вашу электронную почту для сброса пароля',
        SUCCESS: 'Ваш аккаунт успешно восстановлен.',
      },
      REGISTER: {
        TITLE: 'Регистрация',
        ALREADY_HAVE_ACCOUNT: 'Уже есть аккаунт',
        SIGN_IN: 'Войти',
        DESC: 'Введите ваши данные для создания аккаунта',
        SUCCESS: 'Ваш аккаунт успешно зарегистрирован.',
        AGREE: 'Я принимаю',
        TERMS_AND_CONDITIONS: 'условия использования',
        SUBMIT: 'Отправить',
        CANCEL: 'Отмена',
      },
      INPUT: {
        EMAIL: 'Электронная почта',
        FULLNAME: 'Полное имя',
        PASSWORD: 'Пароль',
        NEW_PASSWORD: 'Новый пароль',
        CONFIRM_PASSWORD: 'Подтвердите пароль',
        USERNAME: 'Имя пользователя',
      },
      VALIDATION: {
        INVALID: 'Поле заполнено неверно',
        REQUIRED: 'Поле обязательно для заполнения',
        PATTERN: 'Поле не соответствует шаблону',
        MIN_LENGTH: 'Минимальная длина поля',
        MAX_LENGTH: 'Максимальная длина поля',
        AGREEMENT_REQUIRED: 'Необходимо принять условия',
        NOT_FOUND: 'Запрашиваемый элемент не найден',
        INVALID_LOGIN: 'Неверные данные для входа',
        REQUIRED_FIELD: 'Обязательное поле',
        MIN_LENGTH_FIELD: 'Минимальная длина поля:',
        MAX_LENGTH_FIELD: 'Максимальная длина поля:',
        INVALID_FIELD: 'Поле заполнено неверно',
        MUST_MATCH: 'Пароли не совпадают!',
      },
    },
    DASHBOARD: {
      WELCOME_MESSAGE: 'Добро пожаловать домой',
      LANGUAGE: 'Язык',
      SIGN_OUT: 'Выйти',
    },
    BUTTON: {
      SAVE: 'Сохранить',
      CANCEL: 'Отмена',
      ADD: 'Добавить',
      ADD_ROLE: 'Добавить роль',
      ADD_COMPANY: 'Добавить компанию',
      ADD_AUDIT_TYPE: 'Добавить тип аудита',
      CLOSE: 'Закрыть',
      ADD_RULE_DATABASE: 'Добавить базу правил',
      ADD_DOCUMENT: 'Добавить документ',
      ADD_SECTION: 'Добавить раздел',
      ADD_TYPE_PERMISSION: 'Добавить разрешение типа',
      ADD_RULE_AUTHORITY: 'Добавить полномочие по правилам',
      ADD_RULE_FILE: 'Добавить файл правила',
      ADD_RULE_FOLDER: 'Добавить папку правила',
      ADD_RULE_LINK: 'Добавить ссылку правила',
      EDIT_RULE_LINK: 'Редактировать ссылку правила',
      EDIT_RULE_FOLDER: 'Редактировать папку правила',
      ADD_RULE: 'Добавить правило',
      ADD_USER: 'Добавить пользователя',
    },
    ACCOUNT: {
      OVERVIEW: 'Обзор',
      SETTINGS: 'Настройки',
      PROFILE: 'Профиль',
      PROFILE_DETAILS: 'Данные профиля',
      FULL_NAME: 'Полное имя',
      FIRST_NAME: 'Имя',
      LAST_NAME: 'Фамилия',
      CONTACT_PHONE: 'Контактный телефон',
      COMMUNICATION: 'Связь',
      ALLOW_CHANGES: 'Разрешить изменения',
      LOGOUT: 'Выйти',
      YES: 'Да',
      AVATAR: 'Аватар',
      CHANGE_AVATAR: 'Сменить аватар',
      CHOOSE_FILE: 'Выбрать файл',
      VIEW_ALL_NOTIFICATIONS: 'Просмотреть все уведомления',
      SAVE_CHANGES: 'Сохранить изменения',
      EDIT_PROFILE: 'Редактировать профиль',
      PROFILE_DETAILS_UPDATED: 'Данные профиля обновлены!',
    },
    PROFILE: {
      INFO: {
        TITLE: 'Профиль',
        USER_NAME: 'Имя пользователя',
        ROLE: 'Роль',
        FIRST_NAME: 'Имя',
        LAST_NAME: 'Фамилия',
        CITY: 'Город',
        STATE: 'Область/Регион',
        ZIP: 'Почтовый индекс',
        ADDRESS: 'Адрес',
        PHONE: 'Телефон',
        NOTIFICATIONS: 'Уведомления',
        TIMEZONE: 'Часовой пояс',
        PASSWORD: 'Пароль',
        NEW_PASSWORD: 'Новый пароль',
        EMAIL: 'Электронная почта',
        CONFIRM_NEW_PASSWORD: 'Подтвердите новый пароль',
      },
    },
    ADMINISTRATION: {
      MANAGE_USERS: {
        TITLE: 'Управление пользователями',
        NEW_USER: 'Добавить пользователя',
        FIRST_NAME: 'Имя',
        LAST_NAME: 'Фамилия',
        EMAIL: 'Электронная почта',
        PRIMARY_COMPANY: 'Основная компания',
        USERNAME: 'Имя пользователя',
        AGREED_TO_TERMS: 'Дата согласия с условиями',
        IS_ACTIVE: 'Активен',
        USER_TITLE: 'Должность',
      },
      MANAGE_ROLES: {
        TITLE: 'Управление ролями',
        NAME: 'Название',
        IS_ADMINISTRATIVE: 'Административная роль',
        ADD_ROLE: 'Добавить роль',
        EDIT_ROLE: 'Редактировать роль',
      },
    },
    COMPLIANCE_VIOLATIONS_BREAKDOWN: {
      TITLE: 'Анализ нарушений соответствия',
      COMPANY: 'Компания',
      BRANCH_DEPT: 'Отдел филиала',
      AUDIT_TYPE: 'Тип аудита',
      AUDIT_NAME: 'Название аудита',
      YEAR: 'Год',
      VIOLATIONS_BREAKDOWN: 'Анализ нарушений',
    },
    COMPLIANCE_VIOLATIONS_TRENDING: {
      TITLE: 'Тенденции нарушений соответствия',
      COMPANY: 'Компания',
      BRANCH_DEPT: 'Отдел филиала',
      AUDIT_TYPE: 'Тип аудита',
      AUDIT_NAME: 'Название аудита',
      YEAR: 'Год',
      VIOLATIONS_TRENDING_ANALYSIS: 'Анализ тенденций нарушений',
      VIOLATIONS_TRENDING_ANALYSIS_GRID: 'Анализ тенденций нарушений (таблица)',
    },
    COMPLIANCE: {
      TITLE: 'Соответствие',
    },
    SUPPORT: {
      TITLE: 'Поддержка',
      RESOURCES: 'Ресурсы',
      CONTACT_US: 'Связаться с нами',
      SALES: 'Отдел продаж',
    },
    TYPE_PERMISSION: {
      TARGET_TYPE: 'Тип объекта',
      CREATE: 'Создать',
      READ: 'Чтение',
      WRITE: 'Запись',
      DELETE: 'Удалить',
      NAVIGATE: 'Навигация',
    },
    AUDITS: {
      TITLE: 'Аудиты',
      NAME: 'Название аудита',
      COMPANY: 'Компания',
      AUDIT_TYPE: 'Тип аудита',
      AUDIT_STATUS: 'Статус аудита',
      AUDITOR: 'Аудитор',
      REVIEWER: 'Рецензент',
      COMPLIANCE: 'Соответствие',
      START_DATE: 'Дата начала',
      END_DATE: 'Дата окончания',
      ACTUAL_START_DATE: 'Фактическая дата начала',
      ACTUAL_END_DATE: 'Фактическая дата окончания',
      RECIPIENT: 'Получатель',
      ADDRESS: 'Адрес',
      CITY: 'Город',
      STATE: 'Штат/область',
      ZIP: 'Индекс',
    },
    COMPLIANCE_ANALYSIS: {
      TITLE: 'Анализ соответствия',
    },
    MANAGE_COMPANIES: {
      TITLE: 'Управление компаниями',
      COMPANY_NAME: 'Название компании',
      AUDIT_COMPANY: 'Аудиторская компания',
      BRANCH_DEPARTMENT: 'Отдел филиала',
      CLIENT_TYPE: 'Тип клиента',
      PRIMARY_CONTACT: 'Основной контакт',
      ADDRESS: 'Адрес',
      CITY: 'Город',
      STATE: 'Штат/область',
      ZIP_CODE: 'Почтовый индекс',
      PHONE: 'Телефон',
      WEBSITE: 'Вебсайт',
      TYPE: 'Тип',
    },
    MANAGE_RULE_DATABASE: {
      TITLE: 'Управление базой правил',
      NAME: 'Название базы правил',
      IS_ACTIVE: 'Активна',
      VERSION: 'Версия',
      ORDER: 'Порядок',
      AUTHORITY_NAME: 'Название органа',
    },
    RULE_LINK: {
      TITLE: 'Ссылка на правило',
      IS_ACTIVE: 'Активна',
      RULE_TITLE: 'Название',
      ORDER: 'Порядок',
      FILE: 'Файл',
      NUMBER: 'Номер',
      HYPER_LINK: 'Гиперссылка',
      DISPLAY_TEXT: 'Отображаемый текст',
    },
    RULE_FOLDER: {
      RULE: 'Правило',
      SECTION: 'Раздел',
      SUB_SECTION: 'Подраздел',
      SECTION_TITLE: 'Название раздела',
      SUB_SECTION_TITLE: 'Название подраздела',
      IS_ACTIVE: 'Активна',
    },
    TICKETS: { TITLE: 'Тикеты' },
    SIGN_IN_METHOD: {
      TITLE: 'Метод входа',
      EMAIL_ADDRESS: 'Адрес электронной почты',
      CHANGE_EMAIL: 'Изменить email',
      PASSWORD: 'Пароль',
      CURRENT_PASSWORD: 'Текущий пароль',
      NEW_PASSWORD: 'Новый пароль',
      CONFIRM_CURRENT_PASSWORD: 'Подтвердите новый пароль',
      RESET_PASSWORD: 'Сбросить пароль',
      ENTER_NEW_EMAIL_ADDRESS: 'Введите новый адрес электронной почты',
      UPDATE_EMAIL: 'Обновить email',
      UPDATE_PASSWORD: 'Обновить пароль',
      CANCEL: 'Отмена',
      PASSWORD_WAS_UPDATED: 'Пароль успешно обновлен',
      INCORRECT_PASSWORD: 'Неверный пароль',
      PASSWORD_RULE: 'Пароль должен содержать не менее 6 символов и включать спецсимволы',
      VALIDATION: {
        CURRENT_PASS_REQUIRED: 'Требуется текущий пароль!',
        CURRENT_PASS_MIN: 'Текущий пароль должен содержать не менее 6 символов',
        CURRENT_PASS_MAX: 'Текущий пароль должен содержать максимум 25 символов',
        NEW_PASS_REQUIRED: 'Требуется новый пароль!',
        NEW_PASS_MIN: 'Новый пароль должен содержать не менее 6 символов',
        NEW_PASS_MAX: 'Новый пароль должен содержать максимум 25 символов',
        CONFIRM_PASS_REQUIRED: 'Требуется подтверждение пароля!',
        PASS_DO_NOT_MATCH: 'Пароли не совпадают!',
      },
    },
    FOOTER: {
      POWERED_BY: 'Разработано',
      RIGHTS: 'Все права защищены',
    },
  },
};
